import { RegularManualRosteringComponent } from "./regular-manual-rostering/regular-manual-rostering.component";
import { RegularManualRosteringDeclaration } from "./regular-manual-rostering/regular-manual-rostering.declaration";
import { TemporaryManualRosteringComponent } from "./temporary-manual-rostering/temporary-manual-rostering.component";

export const ManualRosteringDeclaration = [
    TemporaryManualRosteringComponent,
    RegularManualRosteringComponent,
    RegularManualRosteringDeclaration,
];
